<script>
import { mapActions } from "vuex";
import i18n from "@/plugins/i18n";

export default {
  props: {
    su2SurveyId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      elements: [],
    };
  },
  computed: {
    selectedElements() {
      const elements = this.elements.filter(x => x.done).map(x => {
        return {
          sust_element_id: x.sust_element_id,
          sust_element_category_id: x.sust_element_category_id,
        }
      });

      return elements;
    },

    disableSendQuestions() {
      return this.selectedElements.length < 2;
    },

    layoutItems() {
      return [
        {
          category_id: 1,
          text: i18n.t("su2.productQuanlity"),
          bgColor: '#ffa500',
        },
        {
          category_id: 2,
          text: i18n.t("su2.environment"),
          bgColor: '#61a60e',
        },
        {
          category_id: 0,
          text: i18n.t("su2.myChoices"),
          bgColor: '#0e557c',
        },
        {
          category_id: 4,
          text: i18n.t("su2.corporateGovernance"),
          bgColor: '#6262c3',
        },
        {
          category_id: 3,
          text: i18n.t("su2.socialResponsibility"),
          bgColor: '#D93434',
        },
      ];
    },
  },
  methods: {
    ...mapActions("surveys", [
      "editSurveyQuestion",
      "editPostSurveyQuestion"
    ]),

    sendQuestions() {
      if (this.disableSendQuestions)
        return;

      const params = {
        created_by: this.$user.user_id,
        survey_token: this.su2SurveyToken,
        su2_survey_id: this.su2SurveyId,
        sust_elements: this.selectedElements,
      };

      this.editPostSurveyQuestion(params)
        .then(() => {
          this.$toast.open({
            message: "Başarıyla kaydedilmiştir.",
            type: "success",
            duration: 5000,
            dismissible: true,
          });
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        })
    },
    su2Elements() {
      const params = {
        is_deleted: false,
        su2_survey_id: this.su2SurveyId
      };
      this.editSurveyQuestion(params)
        .then((res) => {
          this.elements = res.data;
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        })
    },
  },
  mounted() {
    this.su2Elements()
  },
};
</script>

<template>
  <div class="questions-wrapper flex-all-centered-row">
    <div v-for="layout_item in layoutItems" :key="layout_item.text"
      :style="{'background-color': layout_item.bgColor}"
      class="flex-all-centered-col"
    >
      <h3>
        {{ layout_item.text }}
      </h3>

      <div v-for="
        item in layout_item.category_id != 0 ? 
          elements.filter(x => x.sust_element_category_id === layout_item.category_id) :
          elements.filter(x => x.done === true)
        " 
        :key="item.sust_element_id"
        class="element-row flex-all-centered-row"
      >
        <i v-sust-tooltip="{text: item.sust_element_description, survey_questions: true}" class="fa-solid fa-circle-info"></i>
        <label :for="`element_${item.sust_element_id}`">
          {{ item.sust_element_name }}
        </label>
        <input type="checkbox" :id="`element_${item.sust_element_id}`"
          v-model="item.done"
        >
      </div>

      <h6 v-if="layout_item.category_id === 0 && selectedElements.length === 0">{{ $t("su2.noSelectText") }}</h6>
    </div>

    <button class="sust-btn sust-btn-green"
      :disabled="disableSendQuestions"  @click="sendQuestions()"
    >
      {{ $t("su2.save") }}
    </button>

  </div>
</template>

<style lang="scss" scoped>

.questions-wrapper {
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;

  > div {
    overflow-y: auto;
    width: 30% !important;
    height: 500px !important;
    color: white;

    font-size: 1vw;
    padding: .5vw;
    margin: 0 1vw 1vw 0;
    box-shadow: 0 .1em .25em .1em gray;
    border-top-left-radius: 1em;
    border-bottom-left-radius: 1em;

    justify-content: flex-start;
    align-items: flex-start;

    > .element-row {
      justify-content: flex-start;
      align-items: center;

      > i {
        transform: translateY(-15%);
        padding-right: .3vw;
      }
      
      > label {
        width: 100%;
        padding-right: .3vw;
      }

      > input {
        transform: translateY(-15%);
      }
    }

  }
  
  > button {
    width: 30% !important; 
    margin: 0 1vw 1vw 0 !important;
    box-shadow: none;
  }
}

</style>